import React from "react";
import {Spin} from "antd";

const DEFAULT_MESSAGE = 'Fetching NREL PV Watts Data...';

const ProductionLoader : React.FC<{isPopoutVersion: boolean; message?: string | null}> = ({
    isPopoutVersion,
    message,
}) => {
    const displayMessage = message ?? DEFAULT_MESSAGE;

    return (
        <>
            {
                isPopoutVersion ?
                    <>
                        <Spin className="table_spin"></Spin>
                        <p>{displayMessage}</p>
                    </>
                    :
                    <>
                        <p className={"sideBarLoaderMessage"}> <Spin/> {displayMessage}</p>
                    </>
            }
        </>
    )
}

export default ProductionLoader;